import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxFieldLength(length: number): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    if (value.length > length) {
      return {
        maxFieldLength: {
          length
        }
      };
    }
    return null;
  };
}
